const scrollMenu = {
  init() {
    this.setScroll();
  },

  setScroll() {
    const slider = document.getElementById('jsScrollMenu') as HTMLElement;
    let isDown = false;
    let startX: number;
    let scrollLeft: number;

    if (slider) {
      // Disable scrolling when clicking on links
      const menuLinks = slider.querySelectorAll('a');
      menuLinks.forEach((link) => {
        link.addEventListener('mousedown', (e: MouseEvent) => {
          e.stopPropagation(); // Prevent the scroll from being triggered
        });
      });

      // Scroll functionality when clicking on the menu (not on links)
      slider.addEventListener('mousedown', (e: MouseEvent) => {
        if (e.target instanceof HTMLAnchorElement) {
          return; // Do nothing if the click is on a link
        }

        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('active');
      });

      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('active');
      });

      slider.addEventListener('mousemove', (e: MouseEvent) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 1;
        slider.scrollLeft = scrollLeft - walk;
      });
    }
  },
};

export default scrollMenu;
